import { Union } from "../fable-library.3.1.5/Types.js";
import { array_type, tuple_type, class_type, union_type, lambda_type, unit_type, string_type, bool_type, float64_type, obj_type } from "../fable-library.3.1.5/Reflection.js";
import { keyValueList } from "../fable-library.3.1.5/MapUtil.js";

export class GridLayerProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["TileSize", "Opacity", "UpdateWhenIdle", "UpdateWhenZooming", "UpdateInterval", "Attribution", "ZIndex", "Bounds", "MinZoom", "MaxZoom", "NoWrap", "Pane", "ClassName", "KeepBuffer", "Ref", "Key"];
    }
}

export function GridLayerProps$reflection() {
    return union_type("ReactLeaflet.GridLayerProps", [], GridLayerProps, () => [[["Item", obj_type]], [["Item", float64_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", obj_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class TileLayerProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["TileSize", "Opacity", "UpdateWhenIdle", "UpdateWhenZooming", "UpdateInterval", "Attribution", "ZIndex", "Bounds", "NoWrap", "Pane", "ClassName", "KeepBuffer", "MinZoom", "MaxZoom", "MaxNativeZoom", "MinNativeZoom", "Subdomains", "ErrorTileUrl", "ZoomOffset", "Tms", "ZoomReverse", "DetectRetina", "CrossOrigin", "Url", "OnLoading", "OnLoad", "OnTileLoadstart", "OnTileLoad", "OnTileUnload", "OnTileError", "Ref", "Key"];
    }
}

export function TileLayerProps$reflection() {
    return union_type("ReactLeaflet.TileLayerProps", [], TileLayerProps, () => [[["Item", obj_type]], [["Item", float64_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", obj_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", obj_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.TileEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.TileEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.TileEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.TileEvent"), unit_type)]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class WMSTileLayerProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["TileSize", "Opacity", "UpdateWhenIdle", "UpdateWhenZooming", "UpdateInterval", "Attribution", "ZIndex", "Bounds", "NoWrap", "Pane", "ClassName", "KeepBuffer", "MinZoom", "MaxZoom", "MaxNativeZoom", "MinNativeZoom", "Subdomains", "ErrorTileUrl", "ZoomOffset", "Tms", "ZoomReverse", "DetectRetina", "CrossOrigin", "Url", "Layers", "Styles", "Format", "Transparent", "Version", "Crs", "Uppercase", "OnLoading", "OnLoad", "OnTileLoadstart", "OnTileLoad", "OnTileUnload", "OnTileError", "Ref", "Key"];
    }
}

export function WMSTileLayerProps$reflection() {
    return union_type("ReactLeaflet.WMSTileLayerProps", [], WMSTileLayerProps, () => [[["Item", obj_type]], [["Item", float64_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", obj_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", obj_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", class_type("Leaflet.CRS")]], [["Item", bool_type]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.TileEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.TileEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.TileEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.TileEvent"), unit_type)]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class ImageOverlayProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Pane", "Opacity", "Alt", "Interactive", "Attribution", "CrossOrigin", "Url", "Ref", "Key"];
    }
}

export function ImageOverlayProps$reflection() {
    return union_type("ReactLeaflet.ImageOverlayProps", [], ImageOverlayProps, () => [[["Item", string_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class PathProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Pane", "Attribution", "Interactive", "Stroke", "Color", "Weight", "Opacity", "LineCap", "LineJoin", "DashArray", "DashOffset", "Fill", "FillColor", "FillOpacity", "FillRule", "Renderer", "ClassName", "OnClick", "OnDblClick", "OnMouseDown", "OnMouseOver", "OnMouseOut", "OnContextMenu", "OnAdd", "OnRemove", "OnPopupOpen", "OnPopupClose", "Ref", "Key"];
    }
}

export function PathProps$reflection() {
    return union_type("ReactLeaflet.PathProps", [], PathProps, () => [[["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", class_type("Leaflet.Renderer")]], [["Item", string_type]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.PopupEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.PopupEvent"), unit_type)]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class PolylineProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Pane", "Attribution", "Interactive", "Stroke", "Color", "Weight", "Opacity", "LineCap", "LineJoin", "DashArray", "DashOffset", "Fill", "FillColor", "FillOpacity", "FillRule", "Renderer", "ClassName", "SmoothFactor", "NoClip", "OnClick", "OnDblClick", "OnMouseDown", "OnMouseOver", "OnMouseOut", "OnContextMenu", "OnAdd", "OnRemove", "OnPopupOpen", "OnPopupClose", "Positions", "Ref", "Key"];
    }
}

export function PolylineProps$reflection() {
    return union_type("ReactLeaflet.PolylineProps", [], PolylineProps, () => [[["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", class_type("Leaflet.Renderer")]], [["Item", string_type]], [["Item", float64_type]], [["Item", bool_type]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.PopupEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.PopupEvent"), unit_type)]], [["Item", obj_type]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class PolygonProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["SmoothFactor", "NoClip", "Pane", "Attribution", "Interactive", "Stroke", "Color", "Weight", "Opacity", "LineCap", "LineJoin", "DashArray", "DashOffset", "Fill", "FillColor", "FillOpacity", "FillRule", "Renderer", "ClassName", "OnClick", "OnDblClick", "OnMouseDown", "OnMouseOver", "OnMouseOut", "OnContextMenu", "OnAdd", "OnRemove", "OnPopupOpen", "OnPopupClose", "Positions", "Ref", "Key"];
    }
}

export function PolygonProps$reflection() {
    return union_type("ReactLeaflet.PolygonProps", [], PolygonProps, () => [[["Item", float64_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", class_type("Leaflet.Renderer")]], [["Item", string_type]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.PopupEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.PopupEvent"), unit_type)]], [["Item", obj_type]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class CircleMarkerProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Pane", "Attribution", "Interactive", "Stroke", "Color", "Weight", "Opacity", "LineCap", "LineJoin", "DashArray", "DashOffset", "Fill", "FillColor", "FillOpacity", "FillRule", "Renderer", "ClassName", "Radius", "OnClick", "OnDblClick", "OnMouseDown", "OnMouseOver", "OnMouseOut", "OnContextMenu", "OnAdd", "OnRemove", "OnPopupOpen", "OnPopupClose", "Ref", "Key"];
    }
}

export function CircleMarkerProps$reflection() {
    return union_type("ReactLeaflet.CircleMarkerProps", [], CircleMarkerProps, () => [[["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", class_type("Leaflet.Renderer")]], [["Item", string_type]], [["Item", float64_type]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.PopupEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.PopupEvent"), unit_type)]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class CircleProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Pane", "Attribution", "Interactive", "Stroke", "Color", "Weight", "Opacity", "LineCap", "LineJoin", "DashArray", "DashOffset", "Fill", "FillColor", "FillOpacity", "FillRule", "Renderer", "ClassName", "Radius", "OnClick", "OnDblClick", "OnMouseDown", "OnMouseOver", "OnMouseOut", "OnContextMenu", "OnAdd", "OnRemove", "OnPopupOpen", "OnPopupClose", "Ref", "Key"];
    }
}

export function CircleProps$reflection() {
    return union_type("ReactLeaflet.CircleProps", [], CircleProps, () => [[["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", class_type("Leaflet.Renderer")]], [["Item", string_type]], [["Item", float64_type]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.PopupEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.PopupEvent"), unit_type)]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class GeoJSONProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Pane", "Attribution", "Data", "PointToLayer", "Style", "OnEachFeature", "Filter", "CoordsToLatLng", "OnClick", "OnDblClick", "OnMouseOver", "OnMouseOut", "OnContextMenu", "OnLayerAdd", "OnLayerRemove", "Ref", "Key"];
    }
}

export function GeoJSONProps$reflection() {
    return union_type("ReactLeaflet.GeoJSONProps", [], GeoJSONProps, () => [[["Item", string_type]], [["Item", string_type]], [["Item", class_type("Geojson.GeoJsonObject")]], [["Item", lambda_type(tuple_type(class_type("Geojson.Feature`2", [class_type("Geojson.Point"), obj_type]), class_type("Leaflet.LatLng")), class_type("Leaflet.Layer"))]], [["Item", lambda_type(class_type("Geojson.Feature`2", [class_type("Geojson.GeometryObject"), obj_type]), class_type("Leaflet.PathOptions"))]], [["Item", lambda_type(tuple_type(class_type("Geojson.Feature`2", [class_type("Geojson.GeometryObject"), obj_type]), class_type("Leaflet.Layer")), unit_type)]], [["Item", lambda_type(class_type("Geojson.Feature`2", [class_type("Geojson.GeometryObject"), obj_type]), bool_type)]], [["Item", lambda_type(obj_type, class_type("Leaflet.LatLng"))]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LayerEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LayerEvent"), unit_type)]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class MapProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["PreferCanvas", "AttributionControl", "ZoomControl", "ClosePopupOnClick", "ZoomSnap", "ZoomDelta", "TrackResize", "BoxZoom", "DoubleClickZoom", "Dragging", "Crs", "Layers", "Renderer", "FadeAnimation", "MarkerZoomAnimation", "Transform3DLimit", "ZoomAnimation", "ZoomAnimationThreshold", "Inertia", "InertiaDeceleration", "InertiaMaxSpeed", "EaseLinearity", "WorldCopyJump", "MaxBoundsViscosity", "Keyboard", "KeyboardPanDelta", "ScrollWheelZoom", "WheelDebounceTime", "WheelPxPerZoomLevel", "Tap", "TapTolerance", "TouchZoom", "BounceAtZoomLimits", "Animate", "Bounds", "BoundsOptions", "Center", "ClassName", "Id", "MaxBounds", "MinZoom", "UseFlyTo", "Zoom", "Watch", "SetView", "MaxZoom", "Timeout", "MaximumAge", "EnableHighAccuracy", "Duration", "NoMoveStart", "PaddingTopLeft", "PaddingBottomRight", "Padding", "OnClick", "OnDblClick", "OnMouseDown", "OnMouseUp", "OnMouseOver", "OnMouseOut", "OnMouseMove", "OnContextMenu", "OnFocus", "OnBlur", "OnPreClick", "OnLoad", "OnUnload", "OnViewReset", "OnMove", "OnMoveStart", "OnMoveEnd", "OnDragStart", "OnDrag", "OnDragEnd", "OnZoomStart", "OnZoomEnd", "OnZoomLevelsChange", "OnResize", "OnAutopaSstart", "OnLayerAdd", "OnLayerRemove", "OnBaseLayerChange", "OnOverLayerAdd", "OnOverLayerRemove", "OnLocationFound", "OnLocationError", "OnPopupOpen", "OnPopupClose", "Ref", "Key"];
    }
}

export function MapProps$reflection() {
    return union_type("ReactLeaflet.MapProps", [], MapProps, () => [[["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", obj_type]], [["Item", bool_type]], [["Item", class_type("Leaflet.CRS")]], [["Item", array_type(class_type("Leaflet.Layer"))]], [["Item", class_type("Leaflet.Renderer")]], [["Item", bool_type]], [["Item", bool_type]], [["Item", float64_type]], [["Item", bool_type]], [["Item", float64_type]], [["Item", bool_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", bool_type]], [["Item", float64_type]], [["Item", bool_type]], [["Item", float64_type]], [["Item", obj_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", bool_type]], [["Item", float64_type]], [["Item", obj_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", obj_type]], [["Item", class_type("Leaflet.FitBoundsOptions")]], [["Item", obj_type]], [["Item", string_type]], [["Item", string_type]], [["Item", obj_type]], [["Item", float64_type]], [["Item", bool_type]], [["Item", float64_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", bool_type]], [["Item", float64_type]], [["Item", bool_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.DragEndEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.ResizeEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LayerEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LayerEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LayersControlEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LayersControlEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LayersControlEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LocationEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.ErrorEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.PopupEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.PopupEvent"), unit_type)]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class MapControlProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Position", "Ref", "Key"];
    }
}

export function MapControlProps$reflection() {
    return union_type("ReactLeaflet.MapControlProps", [], MapControlProps, () => [[["Item", string_type]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class ZoomProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Position", "ZoomInText", "ZoomInTitle", "ZoomOutText", "ZoomOutTitle", "Ref", "Key"];
    }
}

export function ZoomProps$reflection() {
    return union_type("ReactLeaflet.ZoomProps", [], ZoomProps, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class PopupProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Offset", "ZoomAnimation", "ClassName", "Pane", "MaxWidth", "MinWidth", "MaxHeight", "AutoPan", "AutoPanPaddingTopLeft", "AutoPanPaddingBottomRight", "AutoPanPadding", "KeepInView", "CloseButton", "AutoClose", "CloseOnClick", "OnClose", "OnOpen", "Position", "Ref", "Key"];
    }
}

export function PopupProps$reflection() {
    return union_type("ReactLeaflet.PopupProps", [], PopupProps, () => [[["Item", obj_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", bool_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", lambda_type(class_type("Leaflet.Popup"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.Popup"), unit_type)]], [["Item", obj_type]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class TooltipProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ZoomAnimation", "ClassName", "Pane", "Offset", "Direction", "Permanent", "Sticky", "Interactive", "Opacity", "OnClose", "OnOpen", "Ref", "Key"];
    }
}

export function TooltipProps$reflection() {
    return union_type("ReactLeaflet.TooltipProps", [], TooltipProps, () => [[["Item", bool_type]], [["Item", string_type]], [["Item", string_type]], [["Item", obj_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", float64_type]], [["Item", lambda_type(class_type("Leaflet.Tooltip"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.Tooltip"), unit_type)]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class MarkerProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Pane", "Attribution", "Interactive", "Icon", "Clickable", "Draggable", "Keyboard", "Title", "Alt", "ZIndexOffset", "Opacity", "RiseOnHover", "RiseOffset", "Position", "OnClick", "OnDblClick", "OnMouseDown", "OnMouseOver", "OnMouseOut", "OnContextMenu", "OnDragStart", "OnDrag", "OnDragEnd", "OnMove", "OnAdd", "OnRemove", "OnPopupOpen", "OnPopupClose", "Ref", "Key"];
    }
}

export function MarkerProps$reflection() {
    return union_type("ReactLeaflet.MarkerProps", [], MarkerProps, () => [[["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", obj_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", bool_type]], [["Item", float64_type]], [["Item", obj_type]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.DragEndEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.PopupEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.PopupEvent"), unit_type)]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class RectangleProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Bounds", "Pane", "Attribution", "Interactive", "Stroke", "Color", "Weight", "Opacity", "LineCap", "LineJoin", "DashArray", "DashOffset", "Fill", "FillColor", "FillOpacity", "FillRule", "Renderer", "ClassName", "OnClick", "OnDblClick", "OnMouseDown", "OnMouseOver", "OnMouseOut", "OnContextMenu", "OnAdd", "OnRemove", "OnPopupOpen", "OnPopupClose", "PopupContainer", "Ref", "Key"];
    }
}

export function RectangleProps$reflection() {
    return union_type("ReactLeaflet.RectangleProps", [], RectangleProps, () => [[["Item", obj_type]], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", class_type("Leaflet.Renderer")]], [["Item", string_type]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.PopupEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.PopupEvent"), unit_type)]], [["Item", class_type("Leaflet.FeatureGroup`1", [obj_type])]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class AttributionControlProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Prefix", "Position", "Ref", "Key"];
    }
}

export function AttributionControlProps$reflection() {
    return union_type("ReactLeaflet.AttributionControlProps", [], AttributionControlProps, () => [[["Item", obj_type]], [["Item", string_type]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class LayersControlProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["BaseLayers", "Overlays", "OnBaseLayerChange", "OnOverLayerAdd", "OnOverLayerRmove", "Ref", "Key"];
    }
}

export function LayersControlProps$reflection() {
    return union_type("ReactLeaflet.LayersControlProps", [], LayersControlProps, () => [[["Item", class_type("Leaflet.ControlModule.LayersObject")]], [["Item", class_type("Leaflet.ControlModule.LayersObject")]], [["Item", lambda_type(class_type("Leaflet.LayersControlEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LayersControlEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LayersControlEvent"), unit_type)]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class ScaleControlProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["MaxWidth", "Metric", "Imperial", "UpdateWhenIdle", "Position", "Ref", "Key"];
    }
}

export function ScaleControlProps$reflection() {
    return union_type("ReactLeaflet.ScaleControlProps", [], ScaleControlProps, () => [[["Item", float64_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class ZoomControlProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ZoomInText", "ZoomInTitle", "ZoomOutText", "ZoomOutTitle", "Position", "Ref", "Key"];
    }
}

export function ZoomControlProps$reflection() {
    return union_type("ReactLeaflet.ZoomControlProps", [], ZoomControlProps, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class PaneProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Name", "Map", "ClassName", "Pane", "Ref", "Key"];
    }
}

export function PaneProps$reflection() {
    return union_type("ReactLeaflet.PaneProps", [], PaneProps, () => [[["Item", string_type]], [["Item", class_type("Leaflet.Map")]], [["Item", string_type]], [["Item", string_type]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class MapLayerProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Pane", "Attribution", "Ref", "Key"];
    }
}

export function MapLayerProps$reflection() {
    return union_type("ReactLeaflet.MapLayerProps", [], MapLayerProps, () => [[["Item", string_type]], [["Item", string_type]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class LayerGroupProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Pane", "Attribution", "Ref", "Key"];
    }
}

export function LayerGroupProps$reflection() {
    return union_type("ReactLeaflet.LayerGroupProps", [], LayerGroupProps, () => [[["Item", string_type]], [["Item", string_type]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export class FeatureGroupProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Pane", "Attribution", "Interactive", "Stroke", "Color", "Weight", "Opacity", "LineCap", "LineJoin", "DashArray", "DashOffset", "Fill", "FillColor", "FillOpacity", "FillRule", "Renderer", "ClassName", "OnClick", "OnDblClick", "OnMouseOver", "OnMouseOut", "OnContextMenu", "OnLayerAdd", "OnLayerRemove", "Ref", "Key"];
    }
}

export function FeatureGroupProps$reflection() {
    return union_type("ReactLeaflet.FeatureGroupProps", [], FeatureGroupProps, () => [[["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", class_type("Leaflet.Renderer")]], [["Item", string_type]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LeafletMouseEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LayerEvent"), unit_type)]], [["Item", lambda_type(class_type("Leaflet.LayerEvent"), unit_type)]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", string_type]]]);
}

export function GridLayerProps_Custom_433E080(key, value) {
    return [key, value];
}

export function TileLayerProps_Custom_433E080(key, value) {
    return [key, value];
}

export function WMSTileLayerProps_Custom_433E080(key, value) {
    return [key, value];
}

export function ImageOverlayProps_Custom_433E080(key, value) {
    return [key, value];
}

export function PathProps_Custom_433E080(key, value) {
    return [key, value];
}

export function PolylineProps_Custom_433E080(key, value) {
    return [key, value];
}

export function PolygonProps_Custom_433E080(key, value) {
    return [key, value];
}

export function CircleMarkerProps_Custom_433E080(key, value) {
    return [key, value];
}

export function CircleProps_Custom_433E080(key, value) {
    return [key, value];
}

export function GeoJSONProps_Custom_433E080(key, value) {
    return [key, value];
}

export function MapProps_Custom_433E080(key, value) {
    return [key, value];
}

export function MapProps_Style_7213C43C(css) {
    return ["style", keyValueList(css, 1)];
}

export function MapControlProps_Custom_433E080(key, value) {
    return [key, value];
}

export function ZoomProps_Custom_433E080(key, value) {
    return [key, value];
}

export function PopupProps_Custom_433E080(key, value) {
    return [key, value];
}

export function TooltipProps_Custom_433E080(key, value) {
    return [key, value];
}

export function MarkerProps_Custom_433E080(key, value) {
    return [key, value];
}

export function RectangleProps_Custom_433E080(key, value) {
    return [key, value];
}

export function AttributionControlProps_Custom_433E080(key, value) {
    return [key, value];
}

export function LayersControlProps_Custom_433E080(key, value) {
    return [key, value];
}

export function ScaleControlProps_Custom_433E080(key, value) {
    return [key, value];
}

export function ZoomControlProps_Custom_433E080(key, value) {
    return [key, value];
}

export function PaneProps_Style_7213C43C(css) {
    return ["style", keyValueList(css, 1)];
}

export function PaneProps_Custom_433E080(key, value) {
    return [key, value];
}

export function MapLayerProps_Custom_433E080(key, value) {
    return [key, value];
}

export function LayerGroupProps_Custom_433E080(key, value) {
    return [key, value];
}

export function FeatureGroupProps_Custom_433E080(key, value) {
    return [key, value];
}

